function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { inputRules } from 'prosemirror-inputrules';
import { createInputRule } from '../utils';
import LinkifyIt from 'linkify-it'; // This is a copy of the linkify-it regex, passing `undefined` for the schema
// will use the default regex.

var linkify = new LinkifyIt(undefined, {
  fuzzyLink: false
});
linkify.add('sourcetree:', 'http:');
var tlds = 'app|biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
var tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
tlds.push(tlds2Char);
linkify.tlds(tlds, false);

function createLinkInputRule(regexp) {
  // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
  return createInputRule(regexp, function (state, match, start, end) {
    var schema = state.schema;

    if (state.doc.rangeHasMark(start, end, schema.marks.link)) {
      return null;
    }

    var _match = _slicedToArray(match, 1),
        link = _match[0];

    var url = normalizeUrl(link.url);
    var markType = schema.mark('link', {
      href: url
    });
    return state.tr.addMark(start - (link.input.length - link.lastIndex), end - (link.input.length - link.lastIndex), markType).insertText(' ');
  });
}

export var LinkMatcher = /*#__PURE__*/function () {
  function LinkMatcher() {
    _classCallCheck(this, LinkMatcher);
  }

  _createClass(LinkMatcher, [{
    key: "exec",
    value: function exec(str) {
      if (str.endsWith(' ')) {
        var chunks = str.slice(0, str.length - 1).split(' ');
        var lastChunk = chunks[chunks.length - 1];
        var links = linkify.match(lastChunk);

        if (links && links.length > 0) {
          var lastLink = links[links.length - 1];
          lastLink.input = lastChunk;
          lastLink.length = lastLink.lastIndex - lastLink.index + 1;
          return [lastLink];
        }
      }

      return null;
    }
  }]);

  return LinkMatcher;
}();
var whitelistedURLPatterns = [/^https?:\/\//im, /^ftps?:\/\//im, /^\//im, /^mailto:/im, /^skype:/im, /^callto:/im, /^facetime:/im, /^git:/im, /^irc6?:/im, /^news:/im, /^nntp:/im, /^feed:/im, /^cvs:/im, /^svn:/im, /^mvn:/im, /^ssh:/im, /^scp:\/\//im, /^sftp:\/\//im, /^itms:/im, /^notes:/im, /^hipchat:\/\//im, /^sourcetree:/im, /^urn:/im, /^tel:/im, /^xmpp:/im, /^telnet:/im, /^vnc:/im, /^rdp:/im, /^whatsapp:/im, /^slack:/im, /^sips?:/im, /^magnet:/im];
export var isSafeUrl = function isSafeUrl(url) {
  return whitelistedURLPatterns.some(function (p) {
    return p.test(url.trim()) === true;
  });
};
export function getLinkMatch(str) {
  var match = str && linkify.match(str);
  return match && match[0];
}
/**
 * Adds protocol to url if needed.
 */

export function normalizeUrl(url) {
  if (!url) {
    return '';
  }

  if (isSafeUrl(url)) {
    return url;
  }

  var match = getLinkMatch(url);
  return match && match.url || '';
}
export function linksInputRules(schema) {
  if (!schema.marks.link) {
    return;
  }

  var urlWithASpaceRule = createLinkInputRule(new LinkMatcher()); // [something](link) should convert to a hyperlink

  var markdownLinkRule = createInputRule(/(^|[^!])\[(.*?)\]\((\S+)\)$/, function (state, match, start, end) {
    var schema = state.schema;

    var _match2 = _slicedToArray(match, 4),
        prefix = _match2[1],
        linkText = _match2[2],
        linkUrl = _match2[3];

    var url = normalizeUrl(linkUrl);
    var markType = schema.mark('link', {
      href: url
    });
    return state.tr.replaceWith(start + prefix.length, end, schema.text(linkText, [markType]));
  });
  return inputRules({
    rules: [urlWithASpaceRule, markdownLinkRule]
  });
}